import { render, staticRenderFns } from "./ListKapal.vue?vue&type=template&id=36fa314d&scoped=true&"
import script from "./ListKapal.vue?vue&type=script&lang=js&"
export * from "./ListKapal.vue?vue&type=script&lang=js&"
import style0 from "./ListKapal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ListKapal.vue?vue&type=style&index=1&id=36fa314d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa314d",
  null
  
)

export default component.exports